import {Action} from '@ngrx/store';
import {ChacraGeo} from "../../../../../chacra-core/models/chacra";

export enum ChacrasGeoActionTypes {
  CHACRAS_GEO_LOAD_REQUEST = '[CHACRAS_GEO] Load Request',
  CHACRAS_GEO_LOAD_FAILURE = '[CHACRAS_GEO] Load Failure',
  CHACRAS_GEO_LOAD_SUCCESS = '[CHACRAS_GEO] Load Success',
}

// load geo
export class ChacrasGeoLoadRequestAction implements Action {
  readonly type = ChacrasGeoActionTypes.CHACRAS_GEO_LOAD_REQUEST;

  constructor(public from: string[]) {}
}

export class ChacrasGeoLoadFailureAction implements Action {
  readonly type = ChacrasGeoActionTypes.CHACRAS_GEO_LOAD_FAILURE;
  constructor(public payload: { error: string }) {
  }
}

export class ChacrasGeoLoadSuccessAction implements Action {
  readonly type = ChacrasGeoActionTypes.CHACRAS_GEO_LOAD_SUCCESS;
  constructor(public payload: { items: ChacraGeo[] }) {
  }
}

// actions

export type ChacrasGeoActions =
  | ChacrasGeoLoadRequestAction
  | ChacrasGeoLoadFailureAction
  | ChacrasGeoLoadSuccessAction;
